// extracted by mini-css-extract-plugin
module.exports = {"layoutHolder":"Layout_layoutHolder__7ZwGW","columnMain":"Layout_columnMain__m1yIU","mainHolder":"Layout_mainHolder__3U819"};